import C from "./index4.js";
import { resolveComponent as p, openBlock as t, createElementBlock as s, Fragment as S, createVNode as d, normalizeClass as c, withCtx as l, createTextVNode as u, toDisplayString as i, createCommentVNode as r, createElementVNode as a, withDirectives as k, vShow as v, withKeys as y, createBlock as I, renderList as T, pushScopeId as A, popScopeId as B } from "vue";
import "./index5.js";
import P from "../../../../_virtual/index.js";
const w = (e) => (A("data-v-a2cfa07a"), e = e(), B(), e), D = { key: 0 }, E = { key: 1 }, N = { key: 2 }, O = { class: "forgot-password-header" }, V = { class: "forgot-password-text" }, R = /* @__PURE__ */ w(() => /* @__PURE__ */ a("div", null, null, -1)), $ = {
  key: 3,
  class: "general-error"
}, L = {
  key: 0,
  class: "email-error"
}, H = { key: 4 }, U = {
  key: 0,
  class: "password-error"
}, W = { key: 1 }, K = {
  key: 0,
  class: "logo-lock-image"
}, G = { class: "dialog-footer-sign-in" }, M = { key: 0 }, z = ["href"], F = ["href"], Y = { key: 2 }, j = /* @__PURE__ */ w(() => /* @__PURE__ */ a("p", null, null, -1)), q = { class: "alert-header-text" }, J = { class: "alert-secondary-text" };
function Q(e, o, X, Z, _, x) {
  const g = p("i18n-t"), f = p("LoadingBar"), m = p("TextInput"), h = p("dialog-layout"), b = p("Button");
  return t(), s(S, null, [
    d(h, {
      isOpen: e.shouldShowDialog,
      "onUpdate:isOpen": o[15] || (o[15] = (n) => e.shouldShowDialog = n),
      variant: e.DIALOGVARIANTS.ACTION,
      imageHeader: e.headerLogo.imageModel,
      class: c(
        "sign-in-dialog " + e.headerLogo.logoClass + (e.productInfo ? " create-account-prompt-backdrop" : "") + (e.hideDialogOnly ? " hide-dialog-only" : "")
      )
    }, {
      default: l(() => [
        e.isSignInSectionShown ? (t(), s("div", D, [
          d(g, {
            keypath: e.productInfo ? "@ado/base-application.sign-in.save-product-login-text" : "@ado/base-application.sign-in.sign-in-text",
            tag: "h1",
            class: "sign-in-header",
            scope: "global"
          }, {
            SiteBrand: l(() => [
              u(i(e.config.sitebrand), 1)
            ]),
            productName: l(() => [
              u(i(e.productInfo?.productName), 1)
            ]),
            _: 1
          }, 8, ["keypath"])
        ])) : r("", !0),
        e.isCreateAccountSectionShown ? (t(), s("div", E, [
          d(g, {
            keypath: "@ado/base-application.sign-in.save-product-create-text",
            tag: "h1",
            class: "save-product-header",
            scope: "global"
          }, {
            productName: l(() => [
              u(i(e.productInfo?.productName), 1)
            ]),
            _: 1
          })
        ])) : r("", !0),
        e.isResetPasswordSectionShown ? (t(), s("div", N, [
          a("h1", O, i(e.t("sign-in.password-reset")), 1),
          a("p", V, i(e.t("sign-in.password-reset-instructions")), 1)
        ])) : r("", !0),
        k(d(f, { message: e.loadingMessage }, null, 8, ["message"]), [
          [v, e.shouldShowLoading]
        ]),
        R,
        e.shouldShowGeneralError ? (t(), s("div", $, i(e.generalError), 1)) : r("", !0),
        a("div", null, [
          d(m, {
            modelValue: e.email,
            "onUpdate:modelValue": o[0] || (o[0] = (n) => e.email = n),
            id: "sign-in-email-input",
            label: e.t("sign-in.email"),
            onKeyup: y(e.handleSubmitButtonClick, ["enter"]),
            onBlur: o[1] || (o[1] = (n) => e.validateEmail(e.email)),
            inputWidth: e.textInputWidth
          }, null, 8, ["modelValue", "label", "onKeyup", "inputWidth"]),
          e.shouldShowEmailError ? (t(), s("span", L, i(e.emailError), 1)) : r("", !0)
        ]),
        e.isResetPasswordSectionShown ? r("", !0) : (t(), s("div", H, [
          d(m, {
            modelValue: e.password,
            "onUpdate:modelValue": o[2] || (o[2] = (n) => e.password = n),
            id: "sign-in-password-input",
            label: e.currentPasswordText,
            onKeyup: y(e.handleSubmitButtonClick, ["enter"]),
            inputWidth: e.textInputWidth,
            variant: e.INPUTVARIANTS.PASSWORD
          }, null, 8, ["modelValue", "label", "onKeyup", "inputWidth", "variant"]),
          e.shouldShowPasswordError ? (t(), s("span", U, i(e.passwordError), 1)) : r("", !0),
          e.isSignInSectionShown ? (t(), s("div", W, [
            a("button", {
              class: "forgot-password-button",
              onClick: o[3] || (o[3] = (n) => e.changeSection(e.Sections.ResetPassword))
            }, i(e.t("sign-in.forgot-password")), 1)
          ])) : r("", !0)
        ])),
        a("div", {
          class: c([
            "submit-container",
            e.isCreateAccountSectionShown || e.isResetPasswordSectionShown ? "closer-submit-container" : ""
          ])
        }, [
          a("button", {
            class: c(["submit-button", e.submitButtonClass]),
            onClick: o[4] || (o[4] = (...n) => e.handleSubmitButtonClick && e.handleSubmitButtonClick(...n))
          }, i(e.submitButtonText), 3),
          e.isCreateAccountSectionShown ? (t(), s("image", K)) : r("", !0)
        ], 2),
        e.isCreateAccountSectionShown ? (t(), s("a", {
          key: 5,
          class: "no-thanks-text",
          onClick: o[5] || (o[5] = (...n) => e.closeDialog && e.closeDialog(...n))
        }, i(e.t("sign-in.no-thanks")), 1)) : r("", !0)
      ]),
      footer: l(() => [
        a("div", G, [
          e.isSignInSectionShown ? (t(), s("div", M, [
            u(i(e.t("sign-in.no-account-text")) + " ", 1),
            e.productInfo ? (t(), s("a", {
              key: 1,
              class: "create-free-account-link",
              onClick: o[7] || (o[7] = (n) => e.changeSection(e.Sections.Create))
            }, i(e.t("sign-in.create-an-account")), 1)) : (t(), s("a", {
              key: 0,
              class: "create-free-account-link",
              href: e.accountCreationLink,
              onClick: o[6] || (o[6] = (...n) => e.navigationEventBus.navigateToHref && e.navigationEventBus.navigateToHref(...n))
            }, i(e.t("sign-in.create-an-account")), 9, z))
          ])) : r("", !0),
          e.isResetPasswordSectionShown ? (t(), I(g, {
            key: 1,
            keypath: "@ado/base-application.sign-in.if-you-prefer",
            tag: "div",
            scope: "global"
          }, {
            create: l(() => [
              e.productInfo ? (t(), s("a", {
                key: 1,
                class: "create-free-account-link",
                onClick: o[9] || (o[9] = (n) => e.changeSection(e.Sections.Create))
              }, i(e.t("sign-in.create-new-account")), 1)) : (t(), s("a", {
                key: 0,
                class: "create-free-account-link",
                href: e.accountCreationLink,
                onClick: o[8] || (o[8] = (...n) => e.navigationEventBus.navigateToHref && e.navigationEventBus.navigateToHref(...n))
              }, i(e.t("sign-in.create-new-account")), 9, F))
            ]),
            return: l(() => [
              a("a", {
                class: "open-sign-in-button",
                onClick: o[10] || (o[10] = (n) => e.changeSection(e.Sections.SignIn))
              }, i(e.t("sign-in.return-sign-in")), 1)
            ]),
            _: 1
          })) : r("", !0),
          e.isCreateAccountSectionShown ? (t(), s("div", Y, [
            u(i(e.t("sign-in.already-have-account")) + " ", 1),
            a("a", {
              onClick: o[11] || (o[11] = (n) => e.changeSection(e.Sections.SignIn)),
              class: "account-link"
            }, i(e.t("sign-in.sign-in")), 1),
            d(g, {
              keypath: "@ado/base-application.sign-in.create-account-disclaimer",
              tag: "p",
              class: "create-account-disclaimer",
              scope: "global"
            }, {
              privacyPolicy: l(() => [
                a("button", {
                  class: "disclaimer-button disclaimer-privacy-policy-link",
                  onClick: o[12] || (o[12] = (...n) => e.showPrivacyPolicyDialog && e.showPrivacyPolicyDialog(...n))
                }, i(e.t("footer.privacy-policy")), 1)
              ]),
              tos: l(() => [
                a("button", {
                  class: "disclaimer-button disclaimer-terms-of-use-link",
                  onClick: o[13] || (o[13] = (...n) => e.showTermsOfUseDialog && e.showTermsOfUseDialog(...n))
                }, i(e.t("footer.terms-of-service")), 1)
              ]),
              emailPolicy: l(() => [
                a("button", {
                  class: "disclaimer-button disclaimer-privacy-policy-link",
                  onClick: o[14] || (o[14] = (...n) => e.showEmailPolicyDialog && e.showEmailPolicyDialog(...n))
                }, i(e.t("sign-in.email-policy")), 1)
              ]),
              _: 1
            }),
            j
          ])) : r("", !0)
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "variant", "imageHeader", "class"]),
    d(h, {
      isOpen: e.showAlert,
      title: e.alertTitle,
      variant: e.DIALOGVARIANTS.ATTENTION
    }, {
      default: l(() => [
        k(a("p", q, [
          a("strong", null, i(e.alertHeaderText), 1)
        ], 512), [
          [v, e.alertHeaderText]
        ]),
        a("div", J, [
          (t(!0), s(S, null, T(e.alertSecondaryText, (n) => (t(), s("p", { key: n }, i(n), 1))), 128))
        ]),
        d(b, {
          class: "alert-button",
          onClick: o[16] || (o[16] = (n) => e.handleAlertDialogButtonClick()),
          variant: e.BUTTONVARIANTS.PRIMARY
        }, {
          default: l(() => [
            u("OK")
          ]),
          _: 1
        }, 8, ["variant"])
      ]),
      _: 1
    }, 8, ["isOpen", "title", "variant"])
  ], 64);
}
const te = /* @__PURE__ */ P(C, [["render", Q], ["__scopeId", "data-v-a2cfa07a"]]);
export {
  te as default
};
//# sourceMappingURL=index3.js.map
